// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"aL","content":"aM","header":"aN","message":"aO","iframeWrapper":"aP"};